import {
  QUERY_KEY_MY_MONITORING_GET_UNIT_TRIGGER,
  QUERY_KEY_MY_MONITORING_GET_UNIT_TRIGGERS
} from '@apps-common/apis/my-monitoring/triggers'
import { QUERY_GET_UNIT_TRIGGERS, QUERY_KEY_GET_UNIT_TRIGGER } from '@apps-common/apis/portal/trigger'
import { queryClient } from '@apps-common/lib'

export const invalidateTriggerQueries = (triggerId?: number, unitId?: string) => {
  // my monitoring
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_MY_MONITORING_GET_UNIT_TRIGGER(triggerId) })
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_MY_MONITORING_GET_UNIT_TRIGGERS(unitId) })
  // portal
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_GET_UNIT_TRIGGER(triggerId) })
  queryClient.invalidateQueries({ queryKey: QUERY_GET_UNIT_TRIGGERS(unitId) })
}
